"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var navigationStepperStyles = styles_1.makeStyles(function (_a) {
    var _b, _c, _d, _e;
    var typography = _a.typography, palette = _a.palette, breakpoints = _a.breakpoints;
    return ({
        stepper: (_b = {
                margin: '60px auto',
                maxWidth: 780,
                width: '100%',
                overflow: 'hidden'
            },
            _b[breakpoints.down(breakpoints.values.md)] = {
                padding: '0 15px',
            },
            _b),
        stepConnector: (_c = {
                borderColor: palette.text.disabled
            },
            _c[breakpoints.down(breakpoints.values.md)] = {
                marginBottom: 20,
            },
            _c),
        stepConnectorCompleted: {
            '& span': {
                borderColor: palette.primary.main,
                borderWidth: 3,
            },
        },
        iconContainer: {
            '& svg': (_d = {
                    width: 40,
                    height: 40
                },
                _d[breakpoints.down(breakpoints.values.sm)] = {
                    width: 32,
                    height: 32,
                },
                _d),
        },
        stepIconText: {
            fontWeight: typography.fontWeightBold,
        },
        stepLabel: (_e = {
                fontSize: typography.fontLG,
                color: palette.text.disabled,
                '& span': {
                    fontWeight: typography.fontWeightBold,
                }
            },
            _e[breakpoints.down(breakpoints.values.sm)] = {
                fontSize: typography.fontMD,
            },
            _e),
        active: {},
        completed: {},
        root: {},
        stepButton: {
            border: 'none',
            '&:hover': {
                border: 'none',
            },
        },
        subHeaderText: {
            width: '100%',
            textAlign: 'center',
            paddingTop: '30px',
        },
    });
}, { name: 'Checkout_NavigationStepper' });
exports.default = navigationStepperStyles;
